
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {CustomApexChart} from "@/plugins/apexcharts";

  @Component({})
  export default class HeaderDashboard extends Vue {
    @Prop() theme: string;

    get dashboardData() { return this.$store.state.dashboard.dashboards.header; }

    get infoData() {
      let rows = [
        { label: 'На парковке', value: this.dashboardData.onParkNow, },
        { label: 'Абонемент', value: this.dashboardData.onParkWithTarif, subRow: true, },
        { label: 'Гости', value: this.dashboardData.onParkGuests, subRow: true, },
        { label: 'Платные', value: this.dashboardData.onParkPayment, subRow: true, },
        { label: 'Свободно', value: this.dashboardData.parkFreePlaces, },
        { label: 'Всего мест', value: this.dashboardData.parkTotalPlaces, },
        { label: 'Сумма', value: this.dashboardData.sum, money: true, },
      ];
      return rows;
    }

    chart = null;
    apexChartName = 'apexchart-dashboard-header';
    series = [];
    isLoading: boolean = true;
    options: any = {
      chart: {
        type: 'pie',
        height: '100%',
        width: '100%',
        toolbar: { show: false },
      },
      series: [],
      dataLabels: {
        enabled: true,
        formatter: null
      },
      tooltip: {
        // y: {
        //   formatter: (value) => this.$options.filters.currency(value, '', ' ', 0),
        // }
      },
      grid: { show: false },
      xaxis: { show: false },
      yaxis: { show: false },
      fill: { opacity: 1 },
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
        fontSize: '14px',
        markers: {
          radius: 12
        }
      }
    };

    created() {
      this.prepareData();
      this.chart = new CustomApexChart(`.${this.apexChartName}`, this.options);
    }

    prepareData() {
      let series = [
        { label: 'Абонемент', value: this.dashboardData.onParkWithTarif, },
        { label: 'Гости', value: this.dashboardData.onParkGuests, },
        { label: 'Платные', value: this.dashboardData.onParkPayment, },
      ];
      this.series = series.map(item => item.value);
      this.options.series = this.series;
      this.options.labels = series.map(item => item.label);
      this.options.dataLabels.formatter = (value, data) => this.series[data.seriesIndex];
    }

    async updateChart() {
      await this.$nextTick();
      this.prepareData();
      if (this.chart.chart) this.chart.chart.updateSeries(this.options.series);
    }

    destroyed() {
      if (this.chart) this.chart.destroyChart();
    }
  }
